import { notEmpty } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import { GlobalSearchModal } from '@festina-life/ui/search'
import { useNavigate } from 'react-router'

import { useConfigurationContext } from '../../context/configurationContext'
import { configurationItem } from '../../system/paths'
import { useNavigationParams } from '../../system/useNavigationParams'
import { useWorkspaceManagerContext } from '../../workspace/workspaceManagerContext'
import { ToggleIconButton } from '../toggleIconButton/ToggleIconButton'
import { ConfigurationItemMatchPreview } from './ConfigurationItemMatchPreview'
import { type ConfigurationItemSearchResult, SearchCategories } from './types'
import { useSearchCategories } from './useSearchCategories'

export const Search = () => {
  const translate = useTranslate()
  const searchCategories = useSearchCategories()
  const navigate = useNavigate()
  const { currentWorkspaceKey } = useWorkspaceManagerContext()
  const { branch, server } = useNavigationParams()
  const { isSearchActive } = useConfigurationContext()

  const handleConfigurationItemSelected = async (
    item: ConfigurationItemSearchResult,
    matchIndex?: number,
  ) => {
    if (item) {
      const matchedItem = notEmpty(matchIndex)
        ? item.matches?.at(matchIndex)
        : undefined

      const propertyPath = matchedItem?.value.propertyPath

      await navigate(
        configurationItem({
          workspaceName: currentWorkspaceKey?.name,
          server,
          itemId: item.value.id,
          layer: item.value.layer,
          block: item.value.block,
          branch,
          type: item.value.operationType,
          path: propertyPath,
        }),
      )
    }
  }

  return (
    <GlobalSearchModal
      title={translate('search.title')}
      categories={searchCategories}
      onSelect={handleConfigurationItemSelected}
      modalClassName="h-[85vh] flex flex-col w-screen px-2 max-w-[min(60vw,1200px)]"
      minQueryLength={1}
      isShowingPreview
      isDisabled={!isSearchActive}
      renderPreview={({ value: result, matchIndex, categoryKey }) => (
        <ConfigurationItemMatchPreview
          layer={result.value.layer}
          block={result.value.block}
          match={result.matches?.at(matchIndex)}
          isShowingCategories={categoryKey === SearchCategories.all}
          operationType={result.value.operationType}
        />
      )}
      trigger={
        <ToggleIconButton
          isActive={false}
          tip={translate('search.searchButton.label')}
          iconName="MagnifyingGlass"
        />
      }
    />
  )
}
